import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// component
import WrapperTicketPage from "../component/WrapperTicketPage";

// helpers
import { getJsonFromUrl } from "helpers";

// actions
import * as Actions from "actions";

const mapStateToProps = (state) => ({
  tickets: state.tickets,
});

const mapDispatchToProps = (dispatch) => ({
  getTickets: () => dispatch(Actions.getTickets()),
  getTicketById: (...args) => dispatch(Actions.getTicketById(...args)),
  createTicket: (...args) => dispatch(Actions.createTicket(...args)),
  deleteTicket: (...args) => dispatch(Actions.deleteTicket(...args)),
  updateTicket: (...args) => dispatch(Actions.updateTicket(...args)),
});
class TicketPage extends Component {
  static propTypes = {
    session: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,

    tickets: PropTypes.array,
    getTickets: PropTypes.func,
    getTicketById: PropTypes.func,
    createTicket: PropTypes.func,
    deleteTicket: PropTypes.func,
    updateTicket: PropTypes.func,
  };

  constructor(...args) {
    super(...args);
    const { location, tickets } = this.props;

    this.state = {
      urlParams: getJsonFromUrl(location),
      loading: tickets.length === 0,
    };
  }

  componentDidMount() {
    console.log("componentDidMount");
    this.refresh();
  }

  async refresh() {
    const { getTickets } = this.props;
    await Promise.all([getTickets()]);

    this.setState({ loading: false });
  }

  render() {
    const {
      history,
      tickets,
      getTicketById,
      createTicket,
      deleteTicket,
      updateTicket,
    } = this.props;

    const { urlParams, loading } = this.state;

    return (
      <WrapperTicketPage
        history={history}
        refresh={this.refresh.bind(this)}
        loading={loading}
        tickets={tickets}
        getTicketById={getTicketById}
        createTicket={createTicket}
        deleteTicket={deleteTicket}
        updateTicket={updateTicket}
        urlParams={urlParams}
      />
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(TicketPage);
